import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import useTranslation from '../../../hooks/useTranslations'
import getInitials from '../../../utils/getInitials'
import SimpleCard from 'ui/modules/cards/simpleCard'
import CompanyCard from 'ui/modules/cards/companyCard'
import { ReactComponent as IconProvider } from 'assets/icons/provider.svg'
import { ReactComponent as IconVerified } from 'assets/icons/verified.svg'
import { ReactComponent as IconDenied } from 'assets/icons/denied.svg'
import CardImage from 'assets/images/cards/company-dashboard.svg'
import { ReactComponent as IconSearch } from 'assets/icons/search.svg'
import { getUserIsAdmin } from 'services/auth/selectors'

const GeneralData = props => {
  const t = useTranslation()
  const { title, company, vendors, stats, avatarImage, goToAddVendor } = props
  const history = useHistory()
  const [userInitials, setUserInitials] = useState('')
  const userIsAdmin = useSelector(getUserIsAdmin)

  useEffect(() => {
    setUserInitials(getInitials(company.name))
  }, [company])

  return (
    <>
      <Box mb={3}>
        <Typography variant="h2">{title}</Typography>
      </Box>
      <Box mb={5}>
        <Grid container spacing={4}>
          <Grid item xs={12} lg={vendors ? 12 : 6}>
            <CompanyCard
              avatarImage={avatarImage}
              avatarName={userInitials}
              company={company.name}
              nif={company.identification_code}
              decorative={vendors ? CardImage : null}
            />
          </Grid>
          {vendors ? (
            <>
              <Grid item xs={12} sm={6} lg={3}>
                <SimpleCard
                  icon={IconProvider}
                  number={stats.vendors.total}
                  text={t('home:my-vendors')}
                  onClickCard={() => history.push('/app/vendors')}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                {stats.saved_searches.total ? (
                  <SimpleCard
                    icon={IconSearch}
                    number={stats.saved_searches.total}
                    text={t('home:saved-searches')}
                    onClickCard={() => history.push('/app/searches#results')}
                  />
                ) : (
                  <SimpleCard
                    icon={IconSearch}
                    number="33"
                    text={t('home:start-search')}
                    isComplex={true}
                    textButton={t('home:new-search')}
                    onClick={() => history.push('/app/searches')}
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                <SimpleCard
                  icon={IconVerified}
                  number={stats.homologated_vendors.total}
                  text={t('home:homologated')}
                  onClickCard={() =>
                    history.push('/app/vendors?homologated=true')
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                <SimpleCard
                  icon={IconDenied}
                  number={stats.no_homologated_vendors.total}
                  text={t('home:not-homologated')}
                  onClickCard={() =>
                    history.push('/app/vendors?homologated=false')
                  }
                />
              </Grid>
            </>
          ) : (
            <>
              {userIsAdmin ? (
                <Grid item xs={12} sm={6} lg={3}>
                  <SimpleCard
                    icon={IconProvider}
                    number="33"
                    text={t('vendor:add')}
                    isComplex={true}
                    textButton={t('vendor:add-first')}
                    onClick={goToAddVendor}
                  />
                </Grid>
              ) : null}

              <Grid
                item
                xs={12}
                sm={!userIsAdmin ? 12 : 6}
                lg={!userIsAdmin ? 6 : 3}
              >
                {stats.saved_searches.total ? (
                  <SimpleCard
                    icon={IconSearch}
                    number={stats.saved_searches.total}
                    text={t('home:saved-searches')}
                    onClickCard={() => history.push('/app/searches')}
                  />
                ) : (
                  <SimpleCard
                    icon={IconSearch}
                    number="33"
                    text={t('home:start-search')}
                    isComplex={true}
                    textButton={t('home:new-search')}
                    onClick={() => history.push('/app/searches')}
                  />
                )}
              </Grid>
            </>
          )}
        </Grid>
      </Box>
    </>
  )
}

GeneralData.propTypes = {
  title: PropTypes.string,
  company: PropTypes.object,
  stats: PropTypes.object,
  goToAddVendor: PropTypes.func,
}

export default GeneralData
